import { useState, useEffect, useCallback, useRef } from 'react';

export const useIdleTimer = (timeout) => {
    const [isIdle, setIsIdle] = useState(false);
    const timerRef = useRef(null);

    const startTimer = useCallback(() => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            setIsIdle(true);
        }, timeout);
    }, [timeout]);

    const reset = useCallback(() => {
        setIsIdle(false);
        startTimer();
    }, [startTimer]);

    useEffect(() => {
        if (timeout === 0) return;

        const handleEvent = () => {
            setIsIdle(false);
            startTimer();
        };

        const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
        events.forEach(event => window.addEventListener(event, handleEvent));

        startTimer();

        return () => {
            events.forEach(event => window.removeEventListener(event, handleEvent));
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [startTimer, timeout]);

    return { isIdle, reset };
};
